import { TENANT_IDS } from "./tenantIds";

const coco = {
    id: TENANT_IDS.COCO,

    branding: {
        appName: 'COCO ERP',
        companyName:    'Ceylon Coco Infresh (Pvt) Ltd.',
        companyShort:   'Coco',
        copyright:      '© 2026 Dockyard Total Solutions',
        tagline:        'Enterprise ERP',
        logoUrl:        '/logo.png',
        loginTitle:     'Sign In to COCO-ERP',
        loginSubtitle:  'Sign in to access COCO-ERP',
        welcomeMessage: "Here's what's happening across COCO systems today.",
        securityBadges: ['🔒 Secure Login', '🛡️ 2FA Enabled', '🔐 SSL Protected'],
    },

    theme: {
        primary: {
            50:  '#ecfdf5', 100: '#d1fae5', 200: '#a7f3d0', 300: '#6ee7b7',
            400: '#34d399', 500: '#10b981', 600: '#059669', 700: '#047857',
            800: '#065f46', 900: '#064e3b',
        },
        chartColors: [
            '#f59e0b', '#3b82f6', '#10b981', '#ef4444',
            '#8b5cf6', '#ec4899', '#14b8a6', '#f97316',
        ],
        accent: {
            solid: '#22c55e', // Tailwind green-500 → was `bg-green-500`
            dark:  '#15803d', // Tailwind green-700 → was `text-green-700`
            tint:  '#eff6ff', // Tailwind blue-50   → was `bg-blue-50`
            ring:  '#bfdbfe', // Tailwind blue-200  → was `ring-blue-200`
        },
    },
}

export default coco;